'use strict';

jQuery(document).ready(function ($) {

	'use strict';

	// Tražilica u navigaciji - testirat jer pisano napamet

	var $navSearchBtn = $('.navbar-search__btn');
	var $navSearchForm = $('#nav-search');
	var $navSearchFormInput = $('#input--search-nav');
	var $navSearchBtnClose = $('#close-btn');

	$('html').on('click', function () {
		$navSearchForm.removeClass('appear');
	});

	$navSearchFormInput.on('click', function (e) {
		e.stopPropagation();
	});

	$navSearchBtn.on('click', function (e) {
		e.stopPropagation();
		$navSearchForm.toggleClass('appear');
		navInputSetFocus();
	});

	// Zatvara tražilicu na mobitelima
	$navSearchBtnClose.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$navSearchForm.toggleClass('appear');
	});

	// Hack za focus na input
	function navInputSetFocus() {
		setTimeout(function () {
			$navSearchFormInput.focus();
		}, 50);
	}

	// Hamburger gumb koji otvara podatke o nama i instagram
	var $hamburgerBtnOpen = $('.navbar-hamburger__btn');
	var $hamburgerBtnClose = $('.navbar-hamburger__btn-close');
	var $hamburger = $('.hamburger');
	$hamburgerBtnOpen.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$hamburger.toggleClass('appear');
	});
	$hamburgerBtnClose.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$hamburger.toggleClass('appear');
	});

	// Galerija 

	var $fancybox = $('a.fancybox');
	if ($fancybox.length) {
		$('a.fancybox').fancybox({
			'transitionIn': 'elastic',
			'transitionOut': 'elastic',
			'speedIn': 600,
			'speedOut': 200,
			'overlayShow': false,
			'padding': 0,
			'margin': 10
			/*      'tpl': {
           closeBtn : '<a title="Zatvori" class="fancybox-item fancybox-close" href="javascript:;">x</a>',
           next     : '<a title="Sljedeći" class="fancybox-nav fancybox-next" href="javascript:;"><</a>',
           prev     : '<a title="Prethodna" class="fancybox-nav fancybox-prev" href="javascript:;">></a>'
      }*/
		});
	}

	// Anchor link smooth scroll

	/*$('a[href*=\\#]').on('click', function(e){     
 	e.preventDefault();
 	// Ubaci anchor ID u URL
 	history.pushState({}, '', this.href);
 	$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
 });*/

	// Scroll to top gumbić u footeru

	var $scrollToTop = $('.scrollToTop');
	$(window).scroll(function () {
		$(this).scrollTop() > 400 ? $scrollToTop.addClass('active') : $scrollToTop.removeClass('active');
	});
	$scrollToTop.click(function () {
		$('html, body').animate({ scrollTop: 0 }, 800);
		return false;
	});

	// Cookie notice settings

	if (Cookies.get('cookie-notice') !== 'Accepted') {
		var $cookieWrapper = $('#bideja-cookie-notice');
		var $cookieBtn = $cookieWrapper.find('#accept-cookie');
		$cookieWrapper.removeClass('bi-remove');
		$cookieBtn.click(function () {
			// Expire je na 5 godina
			Cookies.set('cookie-notice', 'Accepted', { expires: 365 * 5 });
			$cookieWrapper.remove();
		});
	}
});

jQuery(window).load(function () {

	// Sticky sidebar

	/*	var $sticky = jQuery('#sticky');
 	if($sticky.length) {
 		$('#sticky').sticky({
 			topSpacing: 50,
 			bottomSpacing: 100
 		});
 	}*/

});